import { toast } from "sonner";

/**
 * Opens an external URL in a new tab. If the popup is blocked (e.g. inside the
 * Lovable preview iframe where Meta's frame headers can interfere), copies the
 * link to the clipboard and informs the user via a toast.
 */
export function openExternal(url: string) {
  if (!url) return;
  try {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (win && !win.closed) return;
  } catch {
    // ignore — fall through to clipboard fallback
  }
  // Fallback: try to copy to clipboard, but don't crash if permission is denied
  try {
    const p = navigator.clipboard?.writeText(url);
    if (p && typeof p.catch === "function") p.catch(() => {});
    toast("Popup blocked", {
      description: "Link copied — paste it in a new browser tab to chat.",
    });
  } catch {
    toast("Open this link", { description: url });
  }
}
